(function card () {
   const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
   const compName = "card";
   const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
   const Log = logFactory(`${compName}.js`);

    if (!isCompExists(compName, Log)) {
      return;
    }

    $(() => {
      const btnCards = document.querySelectorAll('.card-button');

      const getOriginMobileFromUrl = () => {
        const params = new URLSearchParams(window.location.search);
        return params.get('originMobile'); 
      };

    btnCards.forEach(btnCardItem => {
          btnCardItem.addEventListener('click', (e) => {

        const originMobile = getOriginMobileFromUrl();

        if (!originMobile) {
          return; 
        }

            e.preventDefault();

        const baseHref = btnCardItem.href;

        const separator = baseHref.includes('?') ? '&' : '?';

        const paramsToAdd = [];

        if (originMobile) {
          paramsToAdd.push(`originMobile=${encodeURIComponent(originMobile)}`);
        }
        const redirectTo = paramsToAdd.length
          ? `${baseHref}${separator}${paramsToAdd.join('&')}`
          : baseHref; 

        window.location.replace(redirectTo);
      });
    });
  });
})();